export default {
	setProfile(state, profile) {
		let p = { ...profile, phone: profile.phone || '', profile_url: profile.profile_url || '' };
		p.radiotype = profile.type;
		if (profile.pending_type_change === 'agent') {
			p.radiotype = 'agent';
		}
		if (profile.pending_type_change === 'listed_agent') {
			p.radiotype = 'listed_agent';
		}
		state.profile = p;
	},
	setField(state, data) {
		state.profile[data.fieldName] = data.newVal;
	},
	setSubMarket(state, payload) {
		state.profile.sub_market = payload;
	},
	setMajorMarket(state, payload) {
		state.profile.major_market = payload;
	},
	setCurrentPassword(state, payload) {
		state.currentPassword = payload;
	},
	setNewPassword(state, payload) {
		state.newPassword = payload;
	},
	setRepeatPassword(state, payload) {
		state.repeatPassword = payload;
	},
	setChangePasswordErrors(state, payload) {
		state.changePasswordErrors = payload;
	},
	setSubscription(state, payload) {
		state.subscription = payload;
	},
};
